<script>
import date from 'locutus/php/datetime/date'
import { mapGetters, mapState } from 'vuex'
import { fetchMerchantList } from '@apis/pg'
import { fetchPrivateMarkets } from '@apis/market'
import { fetchCertificationTypes } from '@apis/kyc'
import { fetchFaqList, fetchFaq } from '@apis/cs'
import filter from 'lodash/filter'
import Sitemap from '@components/sitemap'
import DirectKrw from '@components/direct-krw-market'
import QuickService from '@components/quick-service'
import NewsArea from '@components/news-area'
import CompanyLocation from '@components/company-location'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Bank::BankHome',
    meta: [
      {
        name: 'description',
        content: 'Bank::BankHome',
      },
    ],
  },
  components: {
    Sitemap,
    DirectKrw,
    QuickService,
    CompanyLocation,
    NewsArea,
  },
  data() {
    return {
      brand: appConfig.brand,
      faq_list: [],
      faq: null,
      market_list: [],
      merchant_list: [],
      kyc_type_list: [],
      video_id: {
        ko: 'yfV4fvos-aE',
        en: '5BWvavehXq4',
        player_vars: {
          autoplay: 1,
        },
      },
      trade_guide_modal: false,
      news: [
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
        {
          content: this.$t('part_of_news'),
        },
      ],
      // 슬라이드 관련 데이터
      currentSlide: 0,
      autoplayInterval: null,
      progressInterval: null,
      autoplayDelay: 4000, // 4초마다 자동 슬라이드
      progressWidth: 0, // 진행바 너비 (0-100)
      isHovered: false,
      slideItems: [
        {
          title: 'pay_home.home_sec2_online_pay',
          text: 'pay_home.home_sec2_online_text',
          image: require('@assets/images/v2/icon/icon-induce-01.svg'),
          background: require('@assets/images/v2/bg-induce-01.png'),
          mobileBackground: require('@assets/images/v2/bg-induce-m-01.png'),
        },
        {
          title: 'pay_home.home_sec2_voice_invoice',
          text: 'pay_home.home_sec2_voice_text',
          image: require('@assets/images/v2/icon/icon-induce-02.svg'),
          background: require('@assets/images/v2/bg-induce-02.png'),
          mobileBackground: require('@assets/images/v2/bg-induce-m-02.png'),
        },
        {
          title: 'pay_home.home_sec2_exchange_pay',
          text: 'pay_home.home_sec2_exchange_text',
          image: require('@assets/images/v2/icon/icon-induce-03.svg'),
          background: require('@assets/images/v2/bg-induce-03.png'),
          mobileBackground: require('@assets/images/v2/bg-induce-m-03.png'),
        },
        {
          title: 'pay_home.home_sec2_mobile_pay',
          text: 'pay_home.home_sec2_mobile_text',
          image: require('@assets/images/v2/icon/icon-induce-04.svg'),
          background: require('@assets/images/v2/bg-induce-04.png'),
          mobileBackground: require('@assets/images/v2/bg-induce-m-04.png'),
        },
      ],
    }
  },
  computed: {
    ...mapState(['common']),
    ...mapGetters('auth', ['loggedIn']),

    c_active_market() {
      return filter(this.market_list, { is_active: 'Y' })
    },
    trade_guide_video() {
      return this.$refs.youtube.player
    },
    c_faq_contents() {
      return filter(this.faq_list, (list) => list.type_name === 'NOTICE').slice(
        0,
        5
      )
    },
    // 현재 슬라이드의 배경
    currentBackground() {
      return (
        (this.slideItems[this.currentSlide] &&
          this.slideItems[this.currentSlide].background) ||
        this.slideItems[0].background
      )
    },
    // 현재 슬라이드의 모바일 배경
    currentMobileBackground() {
      return (
        (this.slideItems[this.currentSlide] &&
          this.slideItems[this.currentSlide].mobileBackground) ||
        this.slideItems[0].mobileBackground
      )
    },
  },
  mounted() {
    Promise.all([this.loadFaqList()]).catch((e) =>
      this.$toasted.error(e.message)
    )

    if (this.loggedIn) {
      Promise.all([
        this.loadMerchantList(),
        this.loadMarketList(),
        this.loadKycTypeList(),
      ])
        .then(() => this.loadFaqList())
        .catch((e) => this.$toasted.error(e.message))
    } else {
      this.loadMarketList()
    }

    // 슬라이드 자동 재생 시작
    this.startAutoplay()
  },
  beforeDestroy() {
    // 컴포넌트 파괴 시 자동 재생 중지
    this.stopAutoplay()
    this.stopProgressBar()
  },
  methods: {
    date,
    async loadMerchantList() {
      const ret_obj = await fetchMerchantList({
        ...this.$route.query,
      }).catch((e) => this.$toasted.error(e.message))
      this.merchant_list = ret_obj.data
    },
    async loadMarketList() {
      const { data } = await fetchPrivateMarkets().catch((e) =>
        this.$toasted.error(e.message)
      )
      this.market_list = data
    },
    async loadKycTypeList() {
      const ret_obj = await fetchCertificationTypes({
        type_seq: this.$route.params.type_seq * 1,
      }).catch((e) => this.$toasted.error(e.message))
      this.kyc_type_list = ret_obj.data
    },
    openTradeGuideModal() {
      this.trade_guide_modal = true
      if (this.$refs.youtube) this.trade_guide_video.playVideo()
    },
    closeTradeGuideModal() {
      this.trade_guide_modal = false
      this.trade_guide_video.stopVideo()
    },
    moveToTop() {
      window.scrollTo(0, 0)
    },
    async loadFaqList() {
      const ret_obj = await fetchFaqList({
        ...this.$route.query,
        no_paging: 1,
      }).catch((e) => this.$toasted.error(e.message))
      this.faq_list = ret_obj.data
      this.total_count = ret_obj.total_count
      this.total_page = ret_obj.total_page
      this.page_navigation = ret_obj.page_navigation
    },
    async loadFaq() {
      const ret_obj = await fetchFaq().catch((e) =>
        this.$toasted.error(e.message)
      )
      this.faq = ret_obj.data
    },

    goFaq(seq) {
      this.$router.push({
        name: 'contact-notice',
        query: { seq: seq },
      })
    },

    // 슬라이드 관련 메서드들
    nextSlide() {
      if (this.currentSlide < this.slideItems.length - 1) {
        this.currentSlide++
      } else {
        // 마지막 슬라이드에서 첫 번째로 돌아가기
        this.currentSlide = 0
      }
      // 슬라이드 변경 시 진행바 초기화
      this.resetProgressBar()
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      } else {
        // 첫 번째 슬라이드에서 마지막으로 이동
        this.currentSlide = this.slideItems.length - 1
      }
      // 슬라이드 변경 시 진행바 초기화
      this.resetProgressBar()
    },
    // 진행바 시작
    startProgressBar() {
      this.stopProgressBar()
      this.progressWidth = 0

      const progressStep = 100 / (this.autoplayDelay / 50) // 50ms마다 업데이트

      this.progressInterval = setInterval(() => {
        if (!this.isHovered) {
          this.progressWidth += progressStep
          if (this.progressWidth >= 100) {
            this.progressWidth = 100
          }
        }
      }, 50)
    },
    // 진행바 중지
    stopProgressBar() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }
    },
    // 진행바 초기화
    resetProgressBar() {
      this.stopProgressBar()
      this.progressWidth = 0
      this.startProgressBar()
    },
    // 자동 재생 시작
    startAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
      }
      this.autoplayInterval = setInterval(() => {
        if (!this.isHovered) {
          this.nextSlide()
        }
      }, this.autoplayDelay)

      // 진행바도 함께 시작
      this.startProgressBar()
    },
    // 자동 재생 중지
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
        this.autoplayInterval = null
      }
      this.stopProgressBar()
    },
    // 마우스 호버 시 자동 재생 일시정지
    onSlideMouseEnter() {
      this.isHovered = true
    },
    // 마우스 아웃 시 자동 재생 재개
    onSlideMouseLeave() {
      this.isHovered = false
    },
    // 수동 슬라이드 변경 시 자동 재생 재시작
    manualSlideChange(direction) {
      this.stopAutoplay()
      this.stopProgressBar()

      if (direction === 'next') {
        this.nextSlide()
      } else {
        this.prevSlide()
      }

      // 1초 후 자동 재생 재시작 (진행바도 함께)
      setTimeout(() => {
        this.startAutoplay()
      }, 1000)
    },
  },
}
</script>

<template>
  <div class="foreground-container">
    <section id="quick-trade">
      <div class="container layout-flex">
        <div class="info_area">
          <div class="title-area">
            <h2 class="title">
              {{ $t('pay_home.home_sec_trade_h2_1') }}<br />
              {{ $t('pay_home.home_sec_trade_h2_2') }}
            </h2>
            <p class="description">
              {{ $t('pay_home.home_sec_trade_desc') }}
            </p>
          </div>
        </div>
        <DirectKrw></DirectKrw>
        <!-- <HotCoupon></HotCoupon> -->
      </div>
    </section>
    <!-- 트레이드가이드 -->
    <!-- <section class="section introduce-wrap">
      <div class="guide-wrap">
        <div>{{ $t('guide.title') }}</div>
        <a class="detail" @click="openTradeGuideModal">
          <i class="fas fa-video"></i>
          {{ $t('guide.watch_video') }}
        </a>
      </div>
    </section> -->
    <QuickService></QuickService>

    <!-- 찾아 오시는 길, 위치, 뉴스  -->
    <section v-if="0" id="location" class="section">
      <div class="container">
        <CompanyLocation></CompanyLocation>
        <NewsArea></NewsArea>
      </div>
    </section>

    <!-- 원하는 방법으로 결제하세요. -->
    <section
      id="induce-payment"
      class="section"
      :style="{ backgroundImage: `url(${currentBackground})` }"
    >
      <div
        class="mobile-background"
        :style="{ backgroundImage: `url(${currentMobileBackground})` }"
      >
      </div>
      <div class="container">
        <div class="main-title">
          <h2
            >{{ $t('pay_home.home_sec2_h2_01') }}<br />{{
              $t('pay_home.home_sec2_h2_02')
            }}</h2
          >
          <p>
            {{ $t('pay_home.home_sec2_text1') }}
            <br />
            {{ $t('pay_home.home_sec2_text2') }}
            <br />
            {{ $t('pay_home.home_sec2_text3') }}
          </p>
        </div>
        <div
          class="slide-container"
          @mouseenter="onSlideMouseEnter"
          @mouseleave="onSlideMouseLeave"
        >
          <!-- 슬라이드 컨텐츠 -->
          <div class="slide-wrapper">
            <div
              class="slide-track"
              :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
            >
              <div
                v-for="(item, index) in slideItems"
                :key="index"
                class="slide-item"
              >
                <div class="box-list">
                  <div>
                    <h3>{{ $t(item.title) }}</h3>
                    <p>{{ $t(item.text) }}</p>
                  </div>
                  <img :src="item.image" alt="" />
                </div>
              </div>
            </div>
          </div>

          <!-- 슬라이드 컨트롤 -->
          <div class="slide-controls">
            <!-- 진행 바 -->
            <div class="slide-progress">
              <div
                class="progress-bar"
                :style="{ width: progressWidth + '%' }"
              ></div>
            </div>
            <div class="slide-controls-buttons">
              <button
                class="slide-btn prev-btn"
                @click="manualSlideChange('prev')"
              >
                <i class="fas fa-chevron-left"></i>
              </button>

              <div class="slide-indicator">
                <span class="current-index">{{
                  String(currentSlide + 1).padStart(2, '0')
                }}</span>
                <span class="separator">·</span>
                <span class="total-index">{{
                  String(slideItems.length).padStart(2, '0')
                }}</span>
              </div>

              <button
                class="slide-btn next-btn"
                @click="manualSlideChange('next')"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 왜 전 세계 수많은 사업자들이 JPWorld Hold를 신뢰할까요. -->
    <section id="why-pick-bank" class="section text-center">
      <div class="container">
        <div class="main-title">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <h2 v-html="$t('pay_home.home_sec5_h2')"></h2>
          <p
            >{{ $t('pay_home.home_sec5_sub_text_1') }}
            <br />
            {{ $t('pay_home.home_sec5_sub_text_2') }}</p
          >
        </div>
        <div class="box-wrap">
          <div class="box-list">
            <div class="box-top">
              <div class="img-wrap">
                <img
                  src="@assets/images/v2/icon/icon-pick-01.svg"
                  alt="아이콘"
                />
              </div>
              <h3>{{ $t('pay_home.home_sec5_h3') }}</h3>
            </div>
            <p>{{ $t('pay_home.home_sec5_h3_sub1') }}</p>
          </div>
          <div class="box-list">
            <div class="box-top">
              <div class="img-wrap">
                <img
                  src="@assets/images/v2/icon/icon-pick-02.svg"
                  alt="아이콘"
                />
              </div>
              <h3>{{ $t('pay_home.home_sec5_h31') }}</h3>
            </div>
            <p>{{ $t('pay_home.home_sec5_h31_sub1') }}</p>
          </div>
          <div class="box-list">
            <div class="box-top">
              <div class="img-wrap">
                <img
                  src="@assets/images/v2/icon/icon-pick-03.svg"
                  alt="아이콘"
                />
              </div>
              <h3>{{ $t('pay_home.home_sec5_h32') }}</h3>
            </div>
            <p>{{ $t('pay_home.home_sec5_h32_sub1') }}</p>
          </div>
        </div>
        <router-link class="btn btn-primary" :to="{ name: 'register' }">{{
          $t('pay_home.home_sec5_btn')
        }}</router-link>
      </div>
    </section>

    <!-- 글로벌 셀러가 되어보세요. -->
    <!-- <section id="signup-area" class="section">
      <div class="container">
        <div class="main-title">
          <p>{{ $t('pay_home.home_sec9_h2_1') }}</p>
          <h2>{{ $t('pay_home.home_sec9_h2_2') }}</h2>
        </div>
        <div class="btn-wrap">
          <router-link class="btn-white" :to="{ name: 'register' }">
            {{ $t('pay_home.home_sec9_btn') }}
            <div class="img-wrap">
              <img src="@assets/img/longarrow-right-black.svg" />
            </div>
          </router-link>
        </div>
      </div>
    </section> -->

    <!-- USOT 배너 -->
    <section v-if="0" id="ccf-intro">
      <div class="container">
        <div class="main-title">
          <h2>
            USOT
          </h2>
          <p>
            {{ $t('key_coin') }}
          </p>
        </div>
        <div class="btn-wrap">
          <router-link class="btn-white" :to="{ name: 'ccf-intro' }">
            {{ $t('more_view') }}
            <div class="img-wrap">
              <img src="@assets/img/longarrow-right-black.svg" />
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 공지사항 / 고객센터 -->
    <section id="notice" class="section clear">
      <div class="container">
        <div class="notice-area">
          <div class="main-title align-center-title">
            <h2>{{ $t('header.notice') }}</h2>
            <router-link class="more-view" :to="{ name: 'contact-notice' }">
              <span>{{ $t('dash.more') }}</span>
              <div class="img-wrap">
                <img
                  src="@assets/images/v2/icon/icon-arrow-right-blue.svg"
                  alt="화살표"
                />
              </div>
            </router-link>
          </div>
          <div class="notice-list">
            <ul v-if="c_faq_contents.length !== 0">
              <li
                v-for="notice in c_faq_contents"
                :key="notice.seq"
                class="clear"
                @click="goFaq(notice.seq)"
              >
                <router-link :to="{ name: 'contact-notice' }">
                  <img src="@assets/images/v2/icon/icon-notice.svg" alt="" />
                  {{ notice.title }}
                  <span
                    ><img
                      src="@assets/images/v2/icon/icon-arrow-right-black.svg"
                      alt="화살표"
                  /></span>
                </router-link>
                <!-- <span>{{ date('Y-m-d', new Date(notice.regdate)) }}</span> -->
              </li>
            </ul>
            <div v-if="c_faq_contents.length === 0">
              <p>
                {{ $t('no_list') }}
              </p>
            </div>
          </div>
        </div>
        <div class="customer-service">
          <!-- <div class="counsel-area korea-counsel-area">
            <h4>{{ $t('korean_language_counseling') }}</h4>
            <div class="icon">
              <img src="@assets/img/icon-mail.svg" />
            </div>
            <span> korea@jpworldhold.com</span>
            <p>{{ $t('hours_of_business') }}</p>
          </div> -->
          <div class="counsel-area korea-counsel-area">
            <!-- <h4>{{ $t('overseas_consultation') }}</h4> -->
            <h4>{{ $t('service_center.service_center') }}</h4>
            <div class="icon-box">
              <div class="icon">
                <img src="@assets/images/v2/icon/icon-mail.svg" />
              </div>
              <span>
                {{ brand.supportEmail }}
              </span>
            </div>

            <p>
              <!-- Malta - English -->
              {{ $t('hours_of_business') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 유튜브 인가보다. -->
    <!-- <el-dialog
      class="youtube_dial"
      :visible.sync="trade_guide_modal"
      :title="$t('guide.title')"
      :before-close="closeTradeGuideModal"
      :append-to-body="true"
      >
      <youtube
        ref="youtube"
        width="100%"
        :video-id="common.locale === 'ko-KR' ? video_id.ko : video_id.en"
        :player-vars="video_id.player_vars"
      ></youtube>
    </el-dialog> -->

    <!-- 사이트맵 -->
    <section id="sitemap" class="section">
      <div class="container">
        <div class="main-title">
          <h2>
            {{ $t('pay_head_foot.site_map') }}
          </h2>
        </div>
        <Sitemap></Sitemap>
      </div>
    </section>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style lang="scss" scoped>
#induce-payment {
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  transition: background-image 1s ease;
}

.mobile-background {
  z-index: 1;
  display: none;
  height: 240px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  transition: background-image 1s ease;
}
#induce-payment .main-title {
  padding-top: 20px;
}
#induce-payment .main-title p {
  line-height: 22px;
}

#induce-payment .box-list {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 182px;
  padding: 25px 30px;
  background-color: white;
  border: 1px solid #f0f0f0;
  border-radius: 15px;
  gap: 10px;
}
#induce-payment .box-list img {
  width: auto;
}

#induce-payment .box-list h3 {
  margin-bottom: 20px;
  font-size: 20px;
  color: #2a5cda;
}

#induce-payment .box-list p {
  font-size: 16px;
  line-height: 22px;
}

#induce-payment .box-list:last-child {
  margin: 0;
}

/* 슬라이드 컨테이너 스타일 */
.slide-container {
  position: relative;
  width: 603px;
  border-radius: 20px;

  /* 호버 시 일시정지 표시 */
  &:hover::before {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
    padding: 8px 12px;
    font-size: 14px;
    color: white;
    content: '⏸';
    background: rgba(0, 0, 0, 0.7);
    border-radius: 20px;
    opacity: 0;
    animation: fadeIn 0.3s ease forwards;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.slide-controls {
  z-index: 5;
  display: flex;
  flex-direction: column;
}

.slide-controls-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
}

.slide-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  padding: 0;
  color: #333;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;

  i {
    font-size: 18px;
    color: #333;
    transition: color 0.3s ease;
  }
}
.slide-indicator {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;

  .separator {
    margin: 0 5px;
  }

  .total-index {
    color: #7f8894;
  }
}

.slide-progress {
  position: relative;
  z-index: 5;
  width: 100%;
  height: 8px;
  margin-top: 120px;
  margin-bottom: 20px;
  overflow: hidden;
  background: #e5e5e5;
  border-radius: 4px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #0068c1 0%, #2a5cda 100%);
  border-radius: 4px;
  transition: none; /* 부드러운 실시간 애니메이션을 위해 transition 제거 */
}

.slide-wrapper {
  position: relative;
  z-index: 3;
  overflow: hidden;
}

.slide-track {
  display: flex;
  transition: transform 0.6s ease;
}

.slide-item {
  flex-shrink: 0;
  width: 100%;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  #induce-payment {
    padding-top: 0;
    background-image: none !important; /* 모바일에서 데스크탑 배경 숨김 */
  }

  .mobile-background {
    display: block; /* 모바일에서 모바일 배경 표시 */
  }

  #induce-payment .box-list {
    height: 133px;
    padding: 0 20px;
  }
  #induce-payment .box-list h3 {
    padding-bottom: 0;
    margin-bottom: 10px;
    font-size: 16px;
  }
  #induce-payment .box-list p {
    font-size: 12px;
    line-height: 18px;
  }
  .slide-controls {
    padding: 0 10px;
  }

  .slide-btn {
    i {
      font-size: 16px;
    }
  }

  .slide-indicator {
    font-size: 12px;
  }

  .slide-progress {
    height: 6px;
    margin: 20px 0 10px 0;
  }
  .slide-container {
    width: 100%;
  }
}
</style>
